module.exports = __webpack_public_path__ + "static/media/KEITH MONKS MICRO LIGHT.24c7f75f.png";